import React, { PropTypes, Component } from 'react'
import styles from './styles'
import classNames from 'classnames'
import Hint from 'components/hint'
import CornerTriangle from './cornerTriangle'
import TimeSheet from 'components/timesheet'
import OvertimeInput from './overtimeInput'
import OvertimeSpan from './overtimeSpan'
import TrafficSpan from './trafficSpan'
import AutoComplete from 'components/autocomplete'
import misc from 'utils/misc'

class RecordCell extends Component {
  static propTypes = {
    className: PropTypes.string,
    data: PropTypes.object,
    userId: PropTypes.string,
    projectId: PropTypes.string,
    taskId: PropTypes.string,
    weekDay: PropTypes.number,
    dateString: PropTypes.string,
    onRecordUpdate: PropTypes.func,
    readOnly: PropTypes.bool,
  };

  constructor (props, context) {
    super(props, context)
    this.toggleEditMode = ::this.toggleEditMode
    this.onNTimeSelect = ::this.onNTimeSelect
    this.genOnSelect = ::this.genOnSelect
    this.onNoteSelect = ::this.onNoteSelect
    this.onFocusNext = ::this.onFocusNext
    this.getFocusItems = ::this.getFocusItems
  }

  state = {
    editMode: false,
    nTime: this.props.data.nTime,
    oTime: this.props.data.oTime,
    note: this.props.data.note,
    oSegments: (this.props.data.oSegments ? this.props.data.oSegments : []),
    tSegments: (this.props.data.tSegments ? this.props.data.tSegments : []),
  };

  componentWillReceiveProps (nextProps) {
    if (!this.isSameTargetCell(this.props, nextProps) ||
        this.isContentChanged(this.state, nextProps.data)) {
      this.setState({
        editMode: false,
        nTime: nextProps.data.nTime,
        oTime: nextProps.data.oTime,
        note: nextProps.data.note,
        oSegments: (nextProps.data.oSegments ? nextProps.data.oSegments : []),
        tSegments: (nextProps.data.tSegments ? nextProps.data.tSegments : []),
      })
    }
  }

  shouldComponentUpdate (nextProps, nextState) {
    if (this.state.editMode !== nextState.editMode ||
        this.props.readOnly !== nextProps.readOnly ||
        this.props.data.allNotes !== nextProps.data.allNotes ||
        this.isContentChanged(this.state, nextState)
      ) {
      return true
    }
    return false
  }

  onNTimeSelect (item) {
    if (!this.state.editMode) {
      return
    }
    let halfHours = parseFloat(item.split(' ')[0]) * 2
    halfHours = isNaN(halfHours) ? 0 : halfHours
    this.setState({ nTime: halfHours })
  }


  onNoteSelect (item) {
    if (!this.state.editMode) {
      return
    }
    this.setState({ note: item })
  }

  onDelayFocusIndex (curIndex) {
    // wait overtime to update
    window.setTimeout(() => {
      const focusItems = this.getFocusItems()
      focusItems[(curIndex) % focusItems.length].focus()
    }, 20)
  }

  onFocusNext (currentInput) {
    let curIndex = -1
    const focusItems = this.getFocusItems()
    focusItems.forEach((item, i) => {
      if (item === currentInput) {
        curIndex = i
      }
    })

    if (curIndex >= 0) {
      this.onDelayFocusIndex(curIndex + 1)
    } else {
      console.log('error unfound input')
    }
  }

  getFocusItems () {
    const refs = this.refs
    const oSegments = this.state.oSegments
    const tSegments = this.state.tSegments
    const focusItems = []
    focusItems.push(refs.nTimeInput)
    focusItems.push(refs.noteInput)
    let overtimeCount = 0
    for (let i = 0; i < oSegments.length; i++) {
      overtimeCount++
    }
    const isSegmentsFull = oSegments.every(misc.isOSegmentValid)
    if (isSegmentsFull) {
      overtimeCount++
    }
    for (let i = 0; i < overtimeCount; i++) {
      focusItems.push(refs[`overtimeInput${i}`].refs.start)
      focusItems.push(refs[`overtimeInput${i}`].refs.end)
    }

    let trafficCount = 0
    for (let i = 0; i < tSegments.length; i++) {
      trafficCount++
    }
    const isTSegmentsFull = tSegments.every(misc.isOSegmentValid)
    if (isTSegmentsFull) {
      trafficCount++
    }
    for (let i = 0; i < trafficCount; i++) {
      focusItems.push(refs[`trafficInput${i}`].refs.start)
      focusItems.push(refs[`trafficInput${i}`].refs.end)
    }
    return focusItems
  }

  genOnSelect (key, oSegmentsIn, i, isStart, isNew) {
    const oSegments = misc.deepCopy(oSegmentsIn)
    return timeStr => {
      const halfHours = misc.getHalfHours(timeStr)
      // create a new segment
      if (isNew) {
        if (timeStr === '') {
          return
        }
        const newSeg = { start: null, end: null }
        if (isStart) {
          newSeg.start = halfHours
        } else {
          newSeg.end = halfHours
        }
        oSegments.push(newSeg)
        this.setState({ [key]: oSegments })
        return
      }

      // update the old segments
      if (isStart) {
        oSegments[i].start = halfHours
      } else {
        oSegments[i].end = halfHours
      }

      if (misc.isOSegmentWithValue(oSegments[i])) {
        if (oSegments[i].start > oSegments[i].end && halfHours !== null) {
          oSegments[i].end += 48
        }
        this.setState({ [key]: oSegments })
      } else {
        // empty => remove segment[i]
        const newSegs = []
        oSegments.forEach((seg, j) => {
          if (i !== j) {
            newSegs.push(seg)
          }
        })
        this.setState({ [key]: newSegs })
      }
    }
  }

  isSameTargetCell (props, nextProps) {
    return (
      props.data.type !== nextProps.data.type ||
      props.data.colType !== nextProps.data.colType ||
      props.data.rowType !== nextProps.data.rowType ||
      props.data.thisMonday !== nextProps.data.thisMonday ||
      props.userId !== nextProps.userId ||
      props.projectId !== nextProps.projectId ||
      props.taskId !== nextProps.taskId ||
      props.weekDay !== nextProps.weekDay
    )
  }

  isContentChanged (state, data) {
    return (
      state.nTime !== data.nTime ||
      state.oTime !== data.oTime ||
      state.note !== data.note ||
      JSON.stringify(state.oSegments) !== JSON.stringify(data.oSegments) ||
      JSON.stringify(state.tSegments) !== JSON.stringify(data.tSegments)
    )
  }

  toggleEditMode () {
    if (this.state.editMode) {
      const { userId, projectId, taskId, dateString, onRecordUpdate } = this.props
      const record = {}
      record.nTime = this.state.nTime
      record.oSegments = misc.deepCopy(this.state.oSegments)
      record.tSegments = misc.deepCopy(this.state.tSegments)
      record.note = this.state.note
      record.userId = userId
      record.projectId = projectId
      record.taskId = taskId
      record.oSegments = misc.getValidOSegments(record)
      record.tSegments = misc.getValidTSegments(record)
      record.dateString = dateString
      record.isSubmitted = false
      record.isApproved = null

      onRecordUpdate(record)
      this.setState({ editMode: false })
    } else {
      this.setState({ editMode: true })
      this.onDelayFocusIndex(0)
    }
  }

  render () {
    let { nTime, oTime, oSegments, tSegments, note } = this.state
    const { rowType, allNotes } = this.props.data

    nTime = nTime || 0
    oTime = oTime || 0
    oSegments = oSegments || []
    tSegments = tSegments || []
    note = note || null

    const isRecordRow = rowType === TimeSheet.RowType.record

    const withAdditionInfo = isRecordRow && (oTime > 0 || note !== null || tSegments.length !== 0)

    const nTimeClass = classNames(styles.nTime, { [styles.show]: nTime > 0 })

    const oTimeClass = classNames(styles.oTime, { [styles.show]: oTime > 0 })

    // displayMode
    if (!isRecordRow || this.props.readOnly || !this.state.editMode) {
      return (
        <div
          className={this.props.className}
          onClick={(isRecordRow && !this.props.readOnly) ? this.toggleEditMode : null}
        >
          <span className={nTimeClass}>{(nTime / 2.0).toFixed(1)}</span>
          <span className={oTimeClass}>{(oTime / 2.0).toFixed(1)}</span>
          {nTime + oTime === 0 ? <span> </span> : null}

          <CornerTriangle show={withAdditionInfo} />

          {withAdditionInfo ?
            <Hint className={styles.cellHint}>
              <div>{note}</div>
              {oSegments ?
                <div>
                  {oSegments.map((segment, i) =>
                    <OvertimeSpan key={i} segment={segment} />
                  )}
                </div> : null}
              {tSegments ?
                <div>
                  {tSegments.map((segment, i) =>
                    <TrafficSpan key={i} segment={segment} />
                  )}
                </div> : null}
            </Hint> : null
          }

        </div>
      )
    }

    // editMode
    const workHours = []
    for (let halfHours = 1; halfHours <= 16; halfHours++) {
      workHours.push(`${(halfHours / 2.0).toFixed(1)} 小時`)
    }

    const overtimeInputs = []

    for (let i = 0; i < oSegments.length; i++) {
      overtimeInputs.push(
        <OvertimeInput
          key={i}
          segment={oSegments[i]}
          ref={`overtimeInput${i}`}
          onStartTimeSelected={this.genOnSelect('oSegments', oSegments, i, true, false)}
          onEndTimeSelected={this.genOnSelect('oSegments', oSegments, i, false, false)}
          onFocusNext={this.onFocusNext}
        />)
    }

    const isSegmentsFull = oSegments.every(misc.isOSegmentValid)

    if (isSegmentsFull) {
      overtimeInputs.push(
        <OvertimeInput
          key="empty"
          segment={{}}
          ref={`overtimeInput${oSegments.length}`}
          onStartTimeSelected={this.genOnSelect('oSegments', oSegments, -1, true, true)}
          onEndTimeSelected={this.genOnSelect('oSegments', oSegments, -1, false, true)}
          onFocusNext={this.onFocusNext}
        />
      )
    }

    const trafficInputs = []

    for (let i = 0; i < tSegments.length; i++) {
      trafficInputs.push(
        <OvertimeInput
          key={i}
          segment={tSegments[i]}
          ref={`trafficInput${i}`}
          onStartTimeSelected={this.genOnSelect('tSegments', tSegments, i, true, false)}
          onEndTimeSelected={this.genOnSelect('tSegments', tSegments, i, false, false)}
          onFocusNext={this.onFocusNext}
        />)
    }

    const isTSegmentsFull = tSegments.every(misc.isOSegmentValid)

    if (isTSegmentsFull) {
      trafficInputs.push(
        <OvertimeInput
          key="empty"
          segment={{}}
          ref={`trafficInput${tSegments.length}`}
          onStartTimeSelected={this.genOnSelect('tSegments', tSegments, -1, true, true)}
          onEndTimeSelected={this.genOnSelect('tSegments', tSegments, -1, false, true)}
          onFocusNext={this.onFocusNext}
        />
      )
    }

    return (
      <div style={{ position: 'relative' }}>
        <div className={styles.cellEditMode} onClick={this.toggleEditMode}>
          完成
        </div>
        <div className={styles.cellInputForm}>
          <AutoComplete
            ref="nTimeInput"
            value={nTime > 0 ? `${(nTime / 2.0).toFixed(1)} 小時` : ''}
            placeholder="正常工時"
            items={workHours}
            onSelect={this.onNTimeSelect}
            medium
            onFocusNext={this.onFocusNext}
          />
          <br />
          <AutoComplete
            ref="noteInput"
            value={note !== null ? note : ''}
            placeholder="輸入註解"
            items={allNotes}
            onSelect={this.onNoteSelect}
            allowNonItems
            expand
            onFocusNext={this.onFocusNext}
          />
          <br />
          <br />
          加班時段：<br />

          {overtimeInputs}

          交通加班：<br />

          {trafficInputs}

        </div>
      </div>
    )
  }
}


export default RecordCell



// WEBPACK FOOTER //
// ./src/app/components/timesheet/cell/recordCell.jsx